export function normalizeHttpMethod(method: string): string {
  return method.trim().toUpperCase();
}

export function areHttpMethodsEqual(left: string, right: string): boolean {
  return normalizeHttpMethod(left) === normalizeHttpMethod(right);
}

export function addNormalizedHttpMethod({
  methods,
  method,
}: {
  methods: Set<string>;
  method: string;
}): void {
  methods.add(normalizeHttpMethod(method));
}

export function hasOtherHttpMethod({
  methods,
  method,
}: {
  methods: ReadonlySet<string> | undefined;
  method: string;
}): boolean {
  if (!methods) {
    return false;
  }

  const normalizedMethod = normalizeHttpMethod(method);

  for (const siblingMethod of methods) {
    if (normalizeHttpMethod(siblingMethod) !== normalizedMethod) {
      return true;
    }
  }

  return false;
}

export function addHttpMethodToIndex({
  index,
  key,
  method,
}: {
  index: Map<string, Set<string>>;
  key: string;
  method: string;
}): void {
  const methods = index.get(key);

  if (methods) {
    addNormalizedHttpMethod({ methods, method });

    return;
  }

  const created = new Set<string>();

  addNormalizedHttpMethod({ methods: created, method });
  index.set(key, created);
}

export function normalizeHttpHost(host: string): string {
  return host.trim().toLowerCase();
}
